import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ColumnsSpecialItemConverter extends CmsConverterService<ColumnsSpecialItemData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_image_mobile_title_text?.value
    const altText = formData.st_image_mobile_alternative_text?.value
    const lazyLoad = formData.st_image_lazy_loading?.value
    return {
      headline: formData.st_headline ?? defaultTextInput,
      text: formData.st_text ?? defaultTextInput,
      footnote: formData.st_footnote ?? defaultTextInput,
      left: formData.st_position_left?.value ?? 0,
      top: formData.st_position_top?.value ?? 0,
      align: formData.st_align?.value?.identifier ?? 'bottom',
      image: CmsConverterService.mapImage(formData?.st_image_mobile, lazyLoad, altText, title),
      imagePopUp: CmsConverterService.mapImage(formData?.st_image_popup, lazyLoad, altText, title),
      stackImage: formData.st_stack_image?.value ?? false
    }
  }
}

export const COLUMNS_SPECIAL_ITEM_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, ColumnsSpecialItemData>>(
  'ColumnsSpecialItemConverter')

export interface ColumnsSpecialItemData extends ConvertedComponentData {
  headline: TextInput;
  text: TextInput;
  footnote: TextInput;
  image: Image;
  imagePopUp: Image;
  left: number;
  top: number;
  align: string;
  stackImage: boolean;
}
